import { useParams } from 'react-router'
import { usePartnerId } from '@retailer-platform/dashboard/routing'
import { useDomainGoToPath } from './domain/routing'

export interface GoToAccountManagementPageProps {
  accountCanonicalId: string
}

export const useGoToAccountManagementPage = (props: GoToAccountManagementPageProps) => {
  const partnerId = usePartnerId({ throwOnMissing: false })
  const editAccountPath = partnerId
    ? 'partner-account-management-edit'
    : 'app-admin-account-management-edit'

  const goToEditAccount = useDomainGoToPath(editAccountPath, {
    accountCanonicalId: props.accountCanonicalId,
  })

  return goToEditAccount
}
